<template>
  <div class="p-5 font-size-30">
    <div class="font-weight-bold mb-3">Stranica nije pronađena</div>
    <div>Ova stranica ne postoji ili je trenutno nije moguće prikazati</div>
    <div class="font-weight-bold font-size-70 mb-1">404 —</div>
    <router-link to="/" class="btn btn-outline-primary width-100">Nazad</router-link>
  </div>
</template>
<script>
export default {
  name: 'CuiError404',
}
</script>
